import React, { useState } from 'react';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const CustomInput = ({
  type = 'text',
  name = '',
  value,
  onChange,
  onBlur,
  placeholder = '',
  hasError = false,
  sx = {},
  maxLength,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  // Toggle password visibility
  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <TextField
      type={type === 'password' && showPassword ? 'text' : type} // Toggle password visibility
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      variant="outlined"
      size="medium"
      placeholder={placeholder}
      inputProps={{ maxLength }}
      sx={{
        mt: 2,
        width: '350px',
        '& .MuiInputBase-root': {
          height: 40,
          backgroundColor: 'white',
          border: hasError ? '1px solid red' : 'inherit',
        },
        '& .MuiOutlinedInput-input': {
          height: 40,
          width: '100%',
          border: hasError ? '1px solid red' : 'inherit',
          '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px white inset',
            WebkitTextFillColor: 'black',
          },
        },
        ...sx,
      }}
      InputProps={{
        endAdornment:
          type === 'password' ? (
            <InputAdornment position="end">
              <IconButton onClick={handleTogglePassword} edge="end">
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ) : null,
      }}
    />
  );
};

export default CustomInput;
